import { Flex, Image, Link, Modal, ModalContent, ModalOverlay, Text } from '@chakra-ui/react'
import { Button as UbiButton } from '@ubirider/pick-component-library'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import shield from '../../assets/shield.svg'
import { Link as ReactLink } from 'react-router-dom'
import { getCheckoutURL } from '../../api/requests'

export const RedirectModal = ({ orderCode, onClose, isOpen }) => {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)

  async function handleRedirect() {
    setLoading(true)

    try {
      if (orderCode) {
        await window.location.replace(getCheckoutURL() + '?ref=' + orderCode + `&color=#612CD2`)
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ sm: 'xs', md: 'xs', lg: '', xl: '' }}
      trapFocus={false}
      closeOnOverlayClick={false}
      autoFocus={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius='8px'
        maxW='600px'
        padding={{ sm: '16px 24px', md: '16px 24px', lg: '36px', xl: '36px' }}
      >
        <Flex direction='column' gap='48px' align='center'>
          <Flex direction='column' gap='16px' align='center'>
            <Image src={shield} />
            <Flex direction='column' gap='8px' align='center'>
              <Text
                fontWeight='700'
                fontSize={{ sm: '20px', md: '20px', lg: '24px', xl: '24px' }}
                color='neutral.800'
                align='center'
              >
                {t('travel_history.secure_connection_title')}
              </Text>
              <Text
                fontWeight='600'
                fontSize={{ sm: '14px', md: '14px', lg: '16px', xl: '16px' }}
                color='neutral.600'
                align='center'
              >
                {t('travel_history.secure_connection_description')}
              </Text>
            </Flex>
          </Flex>

          <Flex gap='16px' display={{ sm: 'none', md: 'none', lg: 'flex', xl: 'flex' }}>
            <UbiButton
              onClick={onClose}
              style='outline'
              type='neutralDark'
              label={t('authentication.back')}
              css={{ width: '152px' }}
            />
            <UbiButton
              onClick={handleRedirect}
              loading={loading}
              style='solid'
              type='secondary'
              label={t('home.continue')}
              css={{ width: '152px' }}
            />
          </Flex>
          <Flex
            gap='16px'
            alignSelf='stretch'
            direction='column'
            display={{ sm: 'flex', md: 'flex', lg: 'none', xl: 'none' }}
          >
            <UbiButton
              onClick={handleRedirect}
              loading={loading}
              style='solid'
              type='secondary'
              label={t('home.continue')}
              css={{ width: '100%' }}
            />
            <UbiButton
              onClick={onClose}
              style='outline'
              type='neutralDark'
              label={t('authentication.back')}
              css={{ width: '100%' }}
            />
          </Flex>

          <Text fontSize='14px' color='#475467' textAlign='center'>
            <Trans i18nKey='travel_history.payment_partner_redirect_disclaimer'>
              To learn more about how we use your data consult our FAQS and the privacy policies of our partner:{' '}
              <Link
                sx={{ textDecoration: 'underline', fontWeight: '600' }}
                as={ReactLink}
                to='https://www.vivawallet.com/gb_en/privacy-policy'
                isExternal
              >
                Viva Wallet
              </Link>
              .
            </Trans>
          </Text>
        </Flex>
      </ModalContent>
    </Modal>
  )
}
